// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NF_hwnBN_imoUBD8yL3J{list-style:outside}.R0Wmp5GWGqi1vIIYP3VH{list-style:none;padding:4px 10px}.YMhlMCpTCEMmpRW81cb9{padding:8px 10px 8px 0px;margin-left:40px;word-break:keep-all;background:#fff;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "NF_hwnBN_imoUBD8yL3J",
	"head": "R0Wmp5GWGqi1vIIYP3VH",
	"item": "YMhlMCpTCEMmpRW81cb9"
};
export default ___CSS_LOADER_EXPORT___;
